<template>
    <div>

        <!-- Start Blog Details Area -->
        <section class="blog-details-area ptb-80 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="blog-details-desc">
                            <div class="article-image">
                                <img src="../../../../assets/img/blog-image/3.jpg" alt="image">
                            </div>

                            <div class="article-content">
                                <div class="entry-meta">
                                    <ul>
                                        <li><feather type="clock"></feather> <a href="#">September 31, 2020</a></li>
                                        <li><feather type="user"></feather> <a href="#">Steven Smith</a></li>
                                    </ul>
                                </div>

                                <h3>App vs Website: which one is better?</h3>

                                <p>A mobile app will always be for a particular platform and it will not have as much reach as a website. But still here are some good points to consider.</p>
                                <p>An app gives you branding opportunities as it is totally separate from the company's website. It can have a new offer data app exclusively.An app is like a personally tailored cloth, it is highly customisable to your brand liking and it will help you reach your target audience.</p>
                                <p>An app is like a personally tailored cloth, it is highly customisable to your brand liking and it will help you reach your target audience.</p>
                                <p>As it is platform based it can take advantage of the platform and the device such as mobiles and tablets.Sometimes it will give you offline accessibility which is a huge deal in customer service.An app highly increases the customer engagement rate as you can communicate with your customers directly.</p>
                                <p>A website gives you a huge platform to reach a new target audience and it is cheaper as well. Here are some good points to consider. It is highly likely that your customers will find your business by searching on the web as our website is a cross platform product which can reach a broader audience.</p>
                                <p>Depending upon the complexity of your website it can be cost effective for your business as well. Search engine optimization will highly increase your brand visibility on a broader scale which is unique to websites only. when your business will rank higher on the search result then there is a higher possibility that your business will reach a lot of new customers.</p>
                                <p>Search engine optimization will highly increase your brand visibility on a broader scale which is unique to websites only. when your business will rank higher on the search result then there is a higher possibility that your business will reach a lot of new customers</p>
                        </div>
                    </div>

                    
                </div>
                 <div class="col-lg-4 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section class="widget widget_search">
                                <form class="search-form">
                                    <label>
                                        <span class="screen-reader-text">Search for:</span>
                                        <input type="search" class="search-field" placeholder="Search...">
                                    </label>
                                    <button type="submit"><feather type="search"></feather></button>
                                </form>
                            </section>

                            <section class="widget widget_startp_posts_thumb">
                                <h3 class="widget-title">Popular Posts</h3>

                                <article class="item">
                                    <router-link to="/blog-details/WhyECommerce" class="thumb">
                                        <span class="fullimage cover bg1" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2019-06-30">June 10, 2019</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedWebSide" class="thumb">
                                        <span class="fullimage cover bg2" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2019-06-30">June 21, 2019</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedDigitalMarketing" class="thumb">
                                        <span class="fullimage cover bg3" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2019-06-30">June 30, 2019</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                            </section>

                            <section class="widget widget_categories">
                                <h3 class="widget-title">Categories</h3>

                                <ul>
                                    <li><a href="#">Business</a></li>
                                    <li><a href="#">Privacy</a></li>
                                    <li><a href="#">Technology</a></li>
                                    <li><a href="#">Tips</a></li>
                                    <li><a href="#">Uncategorized</a></li>
                                </ul>
                            </section>

                            <section class="widget widget_archive">
                                <h3 class="widget-title">Archives</h3>

                                <ul>
                                    <li><a href="#">May 2019</a></li>
                                    <li><a href="#">April 2019</a></li>
                                    <li><a href="#">June 2019</a></li>
                                </ul>
                            </section>

                            <section class="widget widget_meta">
                                <h3 class="widget-title">Meta</h3>

                                <ul>
                                    <li><a href="#">Log in</a></li>
                                    <li><a href="#">Entries <abbr title="Really Simple Syndication">RSS</abbr></a></li>
                                    <li><a href="#">Comments <abbr title="Really Simple Syndication">RSS</abbr></a></li>
                                    <li><a href="#">WordPress.org</a></li>
                                </ul>
                            </section>

                            <section class="widget widget_tag_cloud">
                                <h3 class="widget-title">Tags</h3>

                                <div class="tagcloud">
                                    <a href="#">IT <span class="tag-link-count"> (3)</span></a>
                                    <a href="#">Spacle <span class="tag-link-count"> (3)</span></a>
                                    <a href="#">Games <span class="tag-link-count"> (2)</span></a>
                                    <a href="#">Fashion <span class="tag-link-count"> (2)</span></a>
                                    <a href="#">Travel <span class="tag-link-count"> (1)</span></a>
                                    <a href="#">Smart <span class="tag-link-count"> (1)</span></a>
                                    <a href="#">Marketing <span class="tag-link-count"> (1)</span></a>
                                    <a href="#">Tips <span class="tag-link-count"> (2)</span></a>
                                </div>
                            </section>
                        </aside>
                    </div>
            </div>
            </div>
        </section>
        <!-- End Blog Details Area -->
    </div>
</template>

<script>
export default {
    name: 'AppVsWeb'
}
</script>